import { signedPrintDisplayName } from '../../shared/signedPrintName.js';
import type { RiftboundCard } from '../types';
import type { DeckCardRef } from '../types/deck';

function renameSignedCard<T extends { name: string }>(card: T): T {
  const name = signedPrintDisplayName(card.name);
  return name === card.name ? card : { ...card, name };
}

/** Show saved decks with `(Signed)` even when Firestore still has the old suffix. */
export function renameSignedPrintCard<T extends { name: string }>(
  card: T | undefined,
): T | undefined {
  if (!card) return card;
  return renameSignedCard(card);
}

export function renameSignedPrintCards<T extends { name: string }>(cards: T[] | undefined): T[] {
  if (!cards?.length) return cards ?? [];
  return cards.map(renameSignedCard);
}

/** Map API/search card data to a deck builder card reference. */
export function riftboundCardToDeckRef(card: RiftboundCard, qty = 1): DeckCardRef {
  return {
    cardId: card.id,
    name: signedPrintDisplayName(card.name),
    qty,
    setCode: card.setCode,
    setName: card.setName,
    number: card.number,
    riftboundId: card.riftboundId,
    originSet: card.originSet,
    imageUrl: card.imageUrl,
    thumbnailUrl: card.thumbnailUrl,
    cardType: card.cardType,
    supertype: card.supertype,
    orientation: card.orientation,
    cost: card.cost,
    might: card.might,
    power: card.power,
    domain: card.domain,
    champion: card.champion,
    tags: card.tags,
    signature: card.signature,
    rarity: card.rarity,
  };
}

/** Map persisted deck slot data to catalog card shape for tray / PDF export. */
export function deckCardRefToRiftboundCard(ref: DeckCardRef): RiftboundCard {
  return {
    id: ref.cardId,
    name: signedPrintDisplayName(ref.name),
    setCode: ref.setCode ?? '',
    setName: ref.setName,
    number: ref.number,
    riftboundId: ref.riftboundId,
    originSet: ref.originSet,
    cardType: ref.cardType ?? '',
    keywords: [],
    supertype: ref.supertype,
    orientation: ref.orientation,
    champion: ref.champion,
    domain: ref.domain,
    cost: ref.cost,
    might: ref.might,
    power: ref.power,
    imageUrl: ref.imageUrl,
    thumbnailUrl: ref.thumbnailUrl,
    signature: ref.signature,
    rarity: ref.rarity,
  };
}
